import { render, staticRenderFns } from "./ColorSpectrum.vue?vue&type=template&id=97fa1db4&scoped=true"
import script from "./ColorSpectrum.vue?vue&type=script&lang=js"
export * from "./ColorSpectrum.vue?vue&type=script&lang=js"
import style0 from "./ColorSpectrum.vue?vue&type=style&index=0&id=97fa1db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fa1db4",
  null
  
)

export default component.exports